import { IPreviewDateTime } from "@/types/components/preview";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const previewDateTimeInitial:IPreviewDateTime = {
    selectedDate: undefined,
    selectedTime: ''
}

const initialState = {
    previewDateTime: previewDateTimeInitial,
    previewDateTimeBackup: previewDateTimeInitial
}

const previewDateTimeSlice = createSlice({
  name: 'previewDateTime',
  initialState,
  reducers: {
    handleSavePreviewDateTimeSettings: (state, action: PayloadAction<Partial<IPreviewDateTime>>) => {
      state.previewDateTime = { ...state.previewDateTime, ...action.payload };
    },
    handleSaveBackupPreviewDateTimeSettings: (state, action: PayloadAction<Partial<IPreviewDateTime>>) => {
        state.previewDateTimeBackup = { ...state.previewDateTimeBackup, ...action.payload };
    },
} })

export const previewDateTimeSelector = createSelector(
  (state: RootState) => state,
  (state) => state.previewDateTime
)

export const {
    handleSavePreviewDateTimeSettings,
    handleSaveBackupPreviewDateTimeSettings
} = previewDateTimeSlice.actions

export default previewDateTimeSlice